import { useEffect, useMemo, useState } from 'react';
import { useTranslator } from '@picsart/rc/services/localization';
import IconArrowRightSmall from '@picsart/icons/IconArrowRightSmall';
import Text from '@picsart/text/Text';
import View from '@picsart/view/View';

import useBatchData from 'pages/Batch/sections/Context/useBatchData';
import { getTargetSizes } from 'pages/Batch/utils/process/resizeProcess';
import { PreviewModalImage, PreviewModalImageBox, PreviewModalZoomWrapper, PreviewModalZoomDesktopActions } from 'pages/Batch/components/PreviewModal/ModalSlices';
import getImageSize from 'pages/Batch/utils/resize/getImageSize';

import useStyles from './styles';

interface IResizeModalContentProps {
    imageSrc: string;
    originalImageSrc: string;
}
const ResizeModalContent = ({ imageSrc, originalImageSrc }: IResizeModalContentProps) => {
  const { resizeParams } = useBatchData();
  const translate = useTranslator();
  const classes = useStyles();

  const [imgSizes, setImgSizes] = useState([0, 0]);

  const [resizedWidth, resizedHeight] = useMemo(() => {
    const width = resizeParams.isOriginal ? imgSizes[0] : resizeParams.width;
    const height = resizeParams.isOriginal ? imgSizes[1] : resizeParams.height;
    return getTargetSizes(imgSizes[0], imgSizes[1], width, height);
  }, [resizeParams, imgSizes]);

  const { width: sizeX, height: sizeY } = getImageSize(imgSizes[0], imgSizes[1]);

  useEffect(() => {
    const img = new Image();
    img.src = originalImageSrc;
    img.onload = () => {
      setImgSizes([img.width, img.height]);
    };
  }, [originalImageSrc]);

  return (
    <>
      <PreviewModalImageBox>
        <PreviewModalZoomWrapper>
          <PreviewModalImage imageSrc={imageSrc} />
        </PreviewModalZoomWrapper>
      </PreviewModalImageBox>
      <PreviewModalZoomDesktopActions />
      <View className={classes.titleContainer} justifyContent="center" alignItems="center">
        <Text className={classes.sizeTitle}>
          {translate('{{sizeX}} x {{sizeY}}', {
            sizeX,
            sizeY,
          })}
        </Text>
        {(imgSizes[0] !== resizedWidth || imgSizes[1] !== resizedHeight) && (
        <>
          <IconArrowRightSmall fill="white" />
          <Text className={classes.sizeTitle}>
            {translate('{{resizedWidth}} x {{resizedHeight}}', {
              resizedWidth,
              resizedHeight,
            })}
          </Text>
        </>
        )}
      </View>
    </>
  );
};

export default ResizeModalContent;
